import { LatestUpdatesType } from '@Types/index';
import { HTML_CHAR } from '@Constants';
import { parseDateTime } from '@Utils/transformDateTime';
import { useGetUploadedImageQuery } from '@Store/api/strapiApiSlice';
import { NewsIcon } from './NewsIcon';

import styles from './carousel-main-item.module.css';

interface CarouselMainItemProps {
  title: string;
  imageSrc: string;
  newsType: LatestUpdatesType;
  publishedAt: string;
  description: string;
}

const CarouselMainItem: React.FC<CarouselMainItemProps> = ({
  description,
  imageSrc,
  newsType,
  publishedAt,
  title,
}) => {
  const { data: strapiImage } = useGetUploadedImageQuery(imageSrc);
  return (
    <div
      className={styles.mainWrapper}
      style={{
        background: `url(${strapiImage})`,
      }}
    >
      <div className={styles.content}>
        <div className={styles.backgroundWrapper}>
          <div className={styles.info}>
            {NewsIcon[newsType]}
            <span>{newsType}</span>
            <span className={styles.dot}>{HTML_CHAR.BULLET}</span>
            <span className={styles.datetime}>
              {parseDateTime(publishedAt, 'DD.MM.YYYY HH:MM')}
            </span>
          </div>
          <div className={styles.title}>{title}</div>
          <div className={styles.description}>{description}</div>
        </div>
      </div>
    </div>
  );
};

export default CarouselMainItem;
